import { render, staticRenderFns } from "./component-img-link.vue?vue&type=template&id=5c598f94&scoped=true&"
import script from "./component-img-link.vue?vue&type=script&lang=js&"
export * from "./component-img-link.vue?vue&type=script&lang=js&"
import style0 from "./component-img-link.vue?vue&type=style&index=0&id=5c598f94&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c598f94",
  null
  
)

export default component.exports